import React from 'react';

import {brandRewardsCopy} from '../../../utils/rewards';

import OfferPanelLayout, {PanelButton} from './OfferPanelLayout';

type OfferNotReadyProps = {
  /** `error`: the offer list failed to load (S6). `empty`: it loaded without this offer (S8). */
  kind: 'error' | 'empty';
  /** Picks the S8 row. `error` ignores it. */
  variant: 'member' | 'not_member';
  onTryAgain: () => void;
  onSeeAllOffers: () => void;
  onJoin: () => void;
  onLearnMore: () => void;
};

const OfferNotReady = ({
  kind,
  variant,
  onTryAgain,
  onSeeAllOffers,
  onJoin,
  onLearnMore,
}: OfferNotReadyProps) => {
  const program = brandRewardsCopy.loyaltyProgramName;

  // Row 3: a signed-in non-member. No "See all offers": the list sends a non-member to HOME.
  if (kind === 'empty' && variant === 'not_member') {
    return (
      <OfferPanelLayout
        testID="exclusive-offer-not-ready"
        heading={`Join ${program} to unlock this offer`}
        body={`This offer is for ${program} members. Join now and we'll bring you straight back to it.`}>
        <PanelButton title={`Join ${program}`} onPress={onJoin} />
        <PanelButton title={`Learn about ${program}`} onPress={onLearnMore} variant="text" />
      </OfferPanelLayout>
    );
  }

  return (
    <OfferPanelLayout
      testID="exclusive-offer-not-ready"
      heading={
        kind === 'error'
          ? "We couldn't load this offer right now"
          : 'Your exclusive offer is on its way'
      }
      body={
        kind === 'error'
          ? 'Your offer may take a moment to appear.'
          : `We're still loading the offers on your ${program} account. This can take a few minutes, so please try again shortly.`
      }>
      <PanelButton title="Try again" onPress={onTryAgain} testID="exclusive-offer-try-again" />
      <PanelButton title="See all offers" onPress={onSeeAllOffers} variant="outlined" />
    </OfferPanelLayout>
  );
};

export default OfferNotReady;
